<i18n src="@/locales/modules/UserSettingsTranslate.json"></i18n>

<template>
	<vx-card no-shadow>
		<form autocomplete="off" ref="formPassword">
			<div class="vx-row w-full">
				<div class="vx-col w-full">
					<vs-input
						type="password"
						v-validate="'required|min:6'"
						:placeholder="$t('OldPassword')"
						:name="$t('OldPassword')"
						v-model="oldpassword"
						class="mt-5 w-full"
						ref="oldpassword"
					/>
					<span class="text-danger text-sm" v-show="errors.has($t('OldPassword'))">{{ errors.first($t("OldPassword")) }}</span>
				</div>
				<div class="vx-col w-full">
					<vs-input
						type="password"
						size="large"
						ref="password"
						:placeholder="$t('NewPassword')"
						v-validate="'min:6|max:20'"
						:data-vv-as="$t('NewPassword')"
						name="password"
						v-model="password"
						class="mt-5 w-full"
					/>
					<span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first("password") }}</span>
				</div>

				<div class="vx-col w-full">
					<vs-input
						type="password"
						size="large"
						v-validate="'min:6|confirmed:password'"
						:data-vv-as="$t('ConfirmNewPassword')"
						:placeholder="$t('ConfirmNewPassword')"
						name="confirm_password"
						v-model="confirm_password"
						class="mt-5 w-full"
					/>
					<span class="text-danger text-sm" v-show="errors.has('confirm_password')">{{ errors.first("confirm_password") }}</span>
				</div>
			</div>
			<div class="vx-row w-full">
				<div class="vx-col w-full">
					<div class="flex flex-wrap items-center sm:justify-end">
						<vs-button class="w-full sm:w-1/3 sm:max-w-xs mt-4 font-bold" @click.prevent="submitForm">{{ $t("Actions.SaveChanges") }}</vs-button>
					</div>
				</div>
			</div>
		</form>
	</vx-card>
</template>

<script>
export default {
	data() {
		return {
			oldpassword: "",
			password: "",
			confirm_password: ""
		};
	},
	computed: {
		activeUserInfo() {
			return this.$store.state.AppActiveUser;
		}
	},
	methods: {
		submitForm() {
			this.$validator
				.validateAll()
				.then(result => {
					this.$refs.formPassword.reset();

					if (result) {
						// if form have no errors
						this.$store
							.dispatch("auth/changePassword", {
								oldPassword: this.oldpassword || "",
								newPassword: this.password || ""
							})
							.then(res => {
								if (res.changePassword) {
									this.$helper.notifySuccess({
										context: this,
										options: {
											title: this.$t("ChangePassword"),
											text: this.$t("ChangePasswordSuccessful")
										}
									});
									this.oldpassword = "";
									this.password = "";
									this.confirm_password = "";
								} else {
									this.$helper.notifyError({
										context: this,
										options: {
											title: this.$t("ChangePassword"),
											text: this.$t("ChangePasswordFailed")
										}
									});
								}
								this.$refs.formPassword.reset();
							})
							.catch(err => {
								this.$vs.notify({ title: this.$t("ChangePassword"), text: err, color: "danger" });
								this.$refs.formPassword.reset();
							});
					} else {
						// form have errors
					}
				})
				.catch(() => {
					this.$vs.notify({ title: this.$t("ChangePassword"), text: this.$t("errors.ChangePassword"), color: "danger" });
					this.$refs.formPassword.reset();
				});
		}
	}
};
</script>
